import React, { useEffect, useState } from "react";
import axios from "axios";
import { Users } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

/**
 * Dropdown to scope admin settings to a specific client.
 * value === "" => global defaults (applies to every client that has no override).
 * value === <client_id> => per-client override.
 */
export default function ClientSelector({ value, onChange }) {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/admin/clients`, { withCredentials: true })
      .then((r) => setClients(Array.isArray(r.data) ? r.data : []))
      .catch(() => setClients([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="flex items-center gap-3 mb-6 px-4 py-3 bg-[#0A0E17] border border-white/10 rounded">
      <Users size={14} className="text-[#00E5FF]" />
      <label className="text-[10px] uppercase tracking-widest text-white/40">
        Scope
      </label>
      <select
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading}
        data-testid="client-selector"
        className="flex-1 bg-black/40 border border-white/10 rounded px-3 py-1.5 text-sm text-white focus:border-[#00E5FF] outline-none"
      >
        <option value="">Default Globale (tutti i clienti)</option>
        {clients.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name || c.id}
          </option>
        ))}
      </select>
      {value && (
        <span className="text-[10px] text-[#00E5FF] uppercase tracking-widest">
          Override attivo
        </span>
      )}
    </div>
  );
}
